export const GET_LOV_CODCOMP2 = 'GET_LOV_CODCOMP2'
export const SET_LOV_CODCOMP2 = 'SET_LOV_CODCOMP2'
export const GET_LOV_CODCOMP2_COLUMNS = 'GET_LOV_CODCOMP2_COLUMNS'
export const SET_LOV_CODCOMP2_COLUMNS = 'SET_LOV_CODCOMP2_COLUMNS'
export const GET_LOV_CODCOMP2_LABELS = 'GET_LOV_CODCOMP2_LABELS'
export const SET_LOV_CODCOMP2_LABELS = 'SET_LOV_CODCOMP2_LABELS'
export const GET_LOV_CODCOMP2_IS_LOADING = 'GET_LOV_CODCOMP2_IS_LOADING'
export const SET_LOV_CODCOMP2_IS_LOADING = 'SET_LOV_CODCOMP2_IS_LOADING'
export const RECEIVED_LOV_CODCOMP2_COLUMNS_LABELS = 'RECEIVED_LOV_CODCOMP2_COLUMNS_LABELS'
export const RECEIVED_LOV_CODCOMP2 = 'RECEIVED_LOV_CODCOMP2'

export const GET_LOV_CODCOMP2_CURRENT_DESC = 'GET_LOV_CODCOMP2_CURRENT_DESC'



// WEBPACK FOOTER //
// ./src/store/modules/hrmsLovCodcomp2/mutation-types.js